import { ButtonColor, ButtonTextColorMap } from "@/common/enum/button-color";
import { Button, FileInput } from "flowbite-react";
import { useRef, useState } from "react";
import { ImageOutlineIcon } from "../icon/ImageOutlineIcon";
import { Body14Regular } from "../typography/Body14Regular";

interface Props {
  onFileChange: React.ChangeEventHandler<HTMLInputElement>;
}

export const ImageCarouselUpdateButton: React.FC<Props> = ({
  onFileChange,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <>
      <Button
        color={ButtonColor.WHITE}
        size="xs"
        onFocus={handleFocus}
        onBlur={handleBlur}
        onClick={handleClick}
      >
        <div className="flex items-center gap-[8px]">
          <ImageOutlineIcon
            size={16}
            color={
              isFocused
                ? "text-primary-black"
                : ButtonTextColorMap[ButtonColor.WHITE]
            }
          />
          <Body14Regular>사진 변경하기</Body14Regular>
        </div>
      </Button>

      <FileInput
        id="dropzone-file"
        className="hidden"
        ref={fileInputRef}
        onChange={onFileChange}
      />
    </>
  );
};
